import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M1.558 6.558a.626.626 0 0 1 .884 0l4.868 4.869c.206.205.334.332.437.42a.498.498 0 0 0 .137.095.377.377 0 0 0 .232 0 .498.498 0 0 0 .137-.095 8.72 8.72 0 0 0 .436-.42l2.738-2.738c.19-.19.36-.36.511-.489.157-.133.336-.258.56-.33a1.624 1.624 0 0 1 1.004 0c.224.072.402.197.56.33.151.129.32.299.511.49l6.802 6.8V10a.625.625 0 1 1 1.25 0v7c0 .345-.28.625-.625.625h-7a.625.625 0 1 1 0-1.25h5.49l-6.8-6.802a8.424 8.424 0 0 0-.437-.42.498.498 0 0 0-.137-.095.377.377 0 0 0-.232 0 .498.498 0 0 0-.137.095 8.424 8.424 0 0 0-.437.42L9.573 12.31c-.19.191-.36.361-.512.49a1.652 1.652 0 0 1-.56.33 1.624 1.624 0 0 1-1.003 0 1.652 1.652 0 0 1-.56-.33c-.151-.129-.32-.299-.511-.49l-4.87-4.868a.626.626 0 0 1 0-.884Z"
    />
  </svg>
`;
